import React from 'react';
import { Shield } from 'lucide-react';

interface HiddenRequestsProps {
  requests: any[];
  onUnhide: (id: string) => void;
  getRemainingTime: (expiresAt: string) => string;
  loading: boolean;
}

export function HiddenRequests({
  requests,
  onUnhide,
  getRemainingTime,
  loading
}: HiddenRequestsProps) {
  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-500">Loading hidden requests...</p>
      </div>
    );
  }

  if (requests.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No hidden requests</p>
      </div>
    );
  }

  return (
    <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {requests.map((request) => (
        <div key={request.request_id} className="bg-white rounded-lg shadow-md p-4">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h3 className="font-medium text-gray-900">
                {request.car_make} {request.car_model}
              </h3>
              <p className="text-sm text-gray-500">
                {request.registration} ({request.car_year})
              </p>
            </div>
            <span className={`text-sm ${
              request.is_expired ? 'text-red-600' : 'text-gray-500'
            }`}>
              {request.is_expired ? 'Expired' : getRemainingTime(request.expires_at)}
            </span>
          </div>
          <div className="mt-4">
            <button
              onClick={() => onUnhide(request.request_id)}
              className="w-full py-2 px-4 rounded-md text-sm bg-blue-600 text-white hover:bg-blue-700"
            >
              Unhide Request
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}